import m from 'mithril';
import MessageProvider from '../../../MessageProvider';
import { RoomTypeResult, RoomType, MultiLangString, TemporaryRoomTypeSelection } from '../../../Models';
import { getValueByLang } from '../../../Utils';
import RoomTypeBookableOptionComponent from '../../common/roomselection/RoomTypeBookableOptionComponent';
import './RoomTypeResultComponent.css'

interface Attrs {
    numberOfRooms: number;
    totalAvailableRoomCount: number;
    roomTypeSelectedCount: number;
    messageProvider: MessageProvider;
    roomTypeResult: RoomTypeResult;
    onOptionSelected: (roomTypeSelection:TemporaryRoomTypeSelection) => void;
    onViewImagesSelected: (photos: string[]) => void;
}

export default function RoomTypeResultComponent(): m.Component<Attrs> {
    let showingTerms = false;

    return {
        view(vnode) {
            const {numberOfRooms, totalAvailableRoomCount, roomTypeSelectedCount, messageProvider, roomTypeResult, onOptionSelected, onViewImagesSelected} = vnode.attrs;
            let roomType: RoomType = roomTypeResult.roomType;  

            return [
                m("div", { class: "card shadow rounded-20" }, [
                    m("div", { class: "row no-gutters" }, [
                         m("div.col-4", {
                            id: roomType.id,
                            onclick: function (event) {
                                event.preventDefault();
                                onViewImagesSelected(roomType.photoUrls);
                            }
                        }, [
                            m("img.card-img img-height rounded-start", {src: (roomType.featuredPhotoUrl != null) ? roomType.featuredPhotoUrl : "https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"}),
                            m("div.card-img-overlay", [
                                m("button", {
                                    class: "btn btn-sm show-room-photos text-white"
                                },
                                    m("i.bi bi-image pr-2"), ((roomType.photoUrls != null) ? roomType.photoUrls.length : 0) +
                                ((roomType.photoUrls != null && roomType.photoUrls.length > 1) ? " " + messageProvider.get("photos") : " " + messageProvider.get("photo")))
                            ]),
                            (roomTypeResult.bookableRoomQuantity == 0) ? 
                            m("div.card-img-overlay img-overlay-padding", [
                                m("div.d-flex flex-row mt-2",
                                    m("strong.text-danger text-center text-capitalize font-weight-bold show-hotel-sold-out px-2 border-danger", "SOLD OUT")
                                )
                            ]) : null
                        ]),
                        m("div", { class: "col-8" }, [
                            m("div.d-flex", [
                                m("div.p-3", [
                                    m("div.pb-2", m("h5.room-name-color", getValueByLang(roomType.name, messageProvider.getCurrentLang()))),

                                    (roomTypeResult.bookableRoomQuantity != 0 && roomTypeResult.bookableRoomQuantity < numberOfRooms)?                                    
                                    m("div.pb-1", 
                                        m("small.text-danger", m("i.bi bi-door-open pr-2"), messageProvider.interpolate(
                                            (roomTypeResult.bookableRoomQuantity > 1)? "number_rooms_left" : "number_room_left", {
                                            count: roomTypeResult.bookableRoomQuantity
                                        }))
                                    ): null,

                                    m("div.mb-1 d-flex",
                                        m("div.pr-2", m("i.bi bi-check-lg text-muted pr-1")),
                                        m("div.ml-auto", {class: "ellipsis-more-than-two-line ellipsis-color"}, [
                                            roomType.amenities.map((amenity, index) => {
                                                let amenityStr: string = ""
                                                if(index < roomType.amenities.length -1){
                                                    amenityStr += getValueByLang(amenity.label, messageProvider.getCurrentLang()) + 
                                                        ((messageProvider.getCurrentLang() == "en")?", ": "၊ ")
                                                }else{
                                                    amenityStr += getValueByLang(amenity.label, messageProvider.getCurrentLang())
                                                }
                                                return m("span.text-sm-left.pr-1 text-muted", amenityStr)
                                            })
                                        ])
                                    ),

                                    (roomTypeResult.valueAddedPromotion != null)?
                                    [
                                        m("div.pt-2 d-flex ellipsis-more-than-two-line", [
                                            m("div.align-self-ceter pr-2", [
                                                m("i.bi bi-gift text-success pr-1 fa-sm"),
                                            ]),
                                            m("div.font-weight-bold", {}, getValueByLang(roomTypeResult.valueAddedPromotion.shortMessage, messageProvider.getCurrentLang()))
                                        ]),
                                    ]:null
                                ]),
                                (roomTypeSelectedCount > 0)? 
                                m("div.ml-auto triangle-down", m("div.show-room-selected-count p-2 text-white", roomTypeSelectedCount)):null
                            ])                                                            
                        ])
                    ]),
                    m("div", {}, 
                        roomTypeResult.bookableOptions.map(function(bookableOption, index){
                            return m(RoomTypeBookableOptionComponent, {
                                numOfRooms: numberOfRooms,
                                totalAvailableRoomCount: totalAvailableRoomCount,
                                hasBookableRooms: ((roomTypeResult.bookableRoomQuantity == numberOfRooms && roomTypeSelectedCount <= roomTypeResult.bookableRoomQuantity)
                                        || (roomTypeResult.bookableRoomQuantity < numberOfRooms && roomTypeSelectedCount < roomTypeResult.bookableRoomQuantity)),
                                messageProvider: messageProvider,
                                roomType: roomTypeResult.roomType,
                                roomTypeBookableOption: bookableOption,
                                numberOfExtraBedsAllowed: roomType.numberOfExtraBedsAllowed,
                                onOptionSelected: (roomTypeSelection:TemporaryRoomTypeSelection) => {
                                    console.log("Room selection ", roomTypeSelection);
                                    onOptionSelected(roomTypeSelection);
                                }
                            });
                        })
                    ),

                    m("div", { class: "p-3 border-top radius-bottom bg-white clickable" ,
                                onclick: function (event:Event) {
                                    showingTerms = !showingTerms;
                                }
                            }, 
                    [
                        m("div", {
                            class: "row"
                        }, [
                            m("div", { class: "col-10" }, messageProvider.get("room_detail")),
                            m("div", { class: "col-2 text-right text-info" },
                                (showingTerms) ?
                                m("i.bi bi-chevron-up") :
                                m("i.bi bi-chevron-down")
                            )
                        ]),

                        (showingTerms) ?
                        m("div", { class: "mt-2" },
                            [
                                (roomTypeResult.valueAddedPromotion != null)?
                                [
                                    m(SectionComponent, {
                                        title: messageProvider.get("special_offer"), 
                                        content: roomTypeResult.valueAddedPromotion.fullMessage, 
                                        messageProvider: messageProvider
                                    })

                                ]:null,

                                (roomType.amenities.length > 0)?
                                [
                                    m("small.text-muted font-weight-bold", messageProvider.get("room_amenity")),
                                    m("div.row mb-3 mt-2", [
                                        roomType.amenities.map(function(amenity){
                                            return  m("div.col-6 pb-2", [
                                                m("div.d-flex bd-highlight", [
                                                    m("div.flex-shrink-1 pr-2 align-self-center", 
                                                        m("img", {
                                                            width: "18",
                                                            height: "18",
                                                            src: amenity.defaultIcon
                                                        })
                                                    ),
                                                    m("div.w-100",  m("span", getValueByLang(amenity.label, messageProvider.getCurrentLang())))
                                                ])
                                            ])
                                        })
                                    ])
                                    
                                ]:null,

                                m(SectionComponent, {
                                    title: messageProvider.get("description"), 
                                    content: roomType.description, 
                                    messageProvider: messageProvider
                                })
                            ]                        
                        ): null 
                    ])
                ])
            ]
        }
    }
}

function SectionComponent(): m.Component<{
    title:string, 
    content:MultiLangString,
    messageProvider: MessageProvider
}> {
    return {
        view(vnode) {
            const {title, content, messageProvider} = vnode.attrs; 
            return [
                m("div.text-muted font-weight-bold", title),
                m("div", { class: "mb-3 mt-2" }, getValueByLang(content, messageProvider.getCurrentLang())
                )
            ]
        }
    }
}